// Module
var code = `<!-- VBL PATTERN — HELLO WORLD -->
<section class="vbl-section" aria-labelledby="vbl-headline">

    <div class="vbl-section__inner">

        <header class="vbl-section__header">
            <p class="vbl-section__label">The pattern</p>
            <h2 id="vbl-headline" class="vbl-section__headline">
                VBL — View, Behavior, Logic
            </h2>
            <p class="vbl-section__sub">
                An evolution of MVC and DCI, designed for how browsers actually work.
                Every SpyneJS application is built from the same three explicit, composable
                parts — from hello world to enterprise scale.
            </p>

            <div class="vbl-section__evolution" aria-label="Pattern evolution">
                <span class="vbl-section__evo-item">MVC</span>
                <span class="vbl-section__evo-arrow" aria-hidden="true">→</span>
                <span class="vbl-section__evo-item">DCI</span>
                <span class="vbl-section__evo-arrow" aria-hidden="true">→</span>
                <span class="vbl-section__evo-item vbl-section__evo-item--active">VBL</span>
                <span class="vbl-section__evo-desc">
          View · Behavior · Logic — the structure that scales with your application, not against it.
        </span>
            </div>
        </header>

        <!-- Example header -->
        <div class="vbl-section__example-header">
            <h3 class="vbl-section__example-title">Hello World — View, Behavior, Logic</h3>
            <p class="vbl-section__example-desc">
                The minimal VBL pattern. No hidden lifecycle logic, no implicit control flow —
                what renders, reacts, and decides are separated and visible from the start.
            </p>
        </div>

        <!-- Live code editor mount point -->
        <div class="vbl-section__codebox">
            <div class="code-container-holder">
                <!-- SpyneJS live code editor mounts here via .code-container -->
            </div>
        </div>

        <footer class="vbl-section__example-footer">
            <p class="vbl-section__example-note">
                The same relationships shown here scale unchanged as the application
                grows in complexity, depth, and scope.
            </p>
            <div class="vbl-section__footer-links">
                <a   data-channel="ROUTE"
                     data-event-prevent-default="true"
                     data-page-id="docs"
                     data-stage="examples"
                     data-text="Docs"
                     href="/docs/examples"
                     class="vbl-section__docs-link">
                    View more examples at spynejs.com/docs/examples →
                </a>
                <a href="https://stackblitz.com/fork/github/nybatista/spynejs-examples/tree/example-vbl?file=src%2Findex.js" target="_blank" class="vbl-section__stackblitz">Edit on StackBlitz ↗</a>
            </div>
        </footer>

    </div>

</section>
`;
// Exports
module.exports = code;